import axios from 'axios';
import {
    MessageBox
} from 'element-ui';
import router from '../router/index.js';
import { Message } from 'element-ui';
import {
    Loading
} from 'element-ui';
import configHttp from '../../configHttp.js';

axios.defaults.timeout = 600000; //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8'; //配置请求头

//axios.defaults.baseURL = 'http://192.168.1.198:8443/manage/';  //配置接口地址 */
axios.defaults.baseURL = configHttp.baseURL;
//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
    //对响应数据做些事
    if (!res.data.success) {
        return Promise.resolve(res);
    }
    return res;
}, (error) => {
    return Promise.reject(error);
});


export default function request(url, method = 'get', params = {}) {
    return new Promise((resolve, reject) => {
        var loading = Loading.service({
            lock: true,
            text: 'loading……',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        var token = localStorage.getItem('token');
        var verifyCodeToken = localStorage.getItem('jwttoken');
        if (token != '' & token != null) {
            axios.defaults.headers.common['token'] = token;
        }
        if (verifyCodeToken != '' && verifyCodeToken != null) {
            axios.defaults.headers.common['jwttoken'] = verifyCodeToken;
        }
        if (method == 'post') {
            axios.post(url, params)
                .then(response => {
                    loading.close();
                    if (response.data.message == 'Session time out.' || response.data.code == '2018') {
                        localStorage.clear();
                        router.push('/login');
                    }

                    resolve(response);
                }, err => {
                    reject(err);
                })
                .catch((error) => {
                    reject(error);
                });
        } else {
            axios.get(url, {
                params: params
            })
                .then(response => {
                    loading.close();
                    if (response.data.message == 'Session time out.' || response.data.code == '2018') {
                        localStorage.clear();
                        router.push('/login');
                    }

                    resolve(response);
                }, err => {
                    reject(err);
                })
                .catch((error) => {
                    reject(error);
                });
        }

    });
}

export function fetchPost(url, params) {
    var token = localStorage.getItem('token');
    var verifyCodeToken = localStorage.getItem('jwttokenverifycode');
    const loading = Loading.service({
        lock: true,
        text: 'loading……',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    if (token != '' & token != null) {
        axios.defaults.headers.common['token'] = token;
    }
    if (verifyCodeToken) {
        axios.defaults.headers.common['jwttokenverifycode'] = verifyCodeToken;
    }
    return new Promise((resolve, reject) => {
        axios.post(url, params)
            .then(response => {
                loading.close();
                resolve(response);
                // if (response.data.message && (response.data.message.indexOf('Session time out.') != -1 || response.data.message.indexOf('no token.') != -1)) {
                // 	localStorage.removeItem('token');
                // 	// this.$route.push('/');
                // 	router.push('/');
                // } else {
                // 	resolve(response);
                // }
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error);
            });
    });
}

////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
    var token = localStorage.getItem('token');
    const loading = Loading.service({
        lock: true,
        text: 'loading……',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    if (token != '' & token != null) {
        axios.defaults.headers.common['token'] = token;
    }
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: param
        })
            .then(response => {
                loading.close();
                resolve(response);
            }, err => {
                reject(err);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
